import React, { useState } from "react";
import "./TweetBox.css";
import { Button } from "@material-ui/core";
import { db } from "../../layouts/firebase";
import Avatar from "@material-ui/core/Avatar";
import imageavatar5 from "assets/img/faces/vn5.jpg";
import VideocamIcon from '@material-ui/icons/Videocam';
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';

function TweetBox() {
  const [tweetMessage, setTweetMessage] = useState("");
  const [tweetImage, setTweetImage] = useState("");

  const sendTweet = (e) => {
    e.preventDefault();

    db.collection("posts").add({
      displayName: "Johnnie Tien",
      username: "johnnietien",
      verified: true,
      text: tweetMessage,
      image: tweetImage,
      avatar: imageavatar5,
    });

    setTweetMessage("");
    setTweetImage("");
  };

  return (
    <div className="tweetBox">
      <form>
        <div className="tweetBox__input">
          <Avatar src={imageavatar5} />
          <input
            onChange={(e) => setTweetMessage(e.target.value)}
            value={tweetMessage}
            placeholder="Bạn muốn chia sẻ điều gì?"
            type="text"
          />
          <input
          value={tweetImage}
          onChange={(e) => setTweetImage(e.target.value)}
          className="tweetBox__imageInput"
          placeholder="Tạm thời nhập link hình ảnh"
          type="text"
        />
        <Button color="secondary"
          onClick={sendTweet}
          type="submit"
          className="tweetBox__tweetButton"
        >
          Post
        </Button>
        </div>
        
        
        
        
        
      </form>
      <div className="messageSender__bottom">
                <div className="messageSender__option">
                    <VideocamIcon style={{color: "red"}} />
                    <h3>Live Video</h3>
                </div>

                <div className="messageSender__option">
                    <PhotoLibraryIcon style={{color: "green"}} />
                    <h3>Photo/Video</h3>
                </div>

                <div className="messageSender__option">
                    <InsertEmoticonIcon style={{color: "orange"}} />
                    <h3>Feeling/Activity</h3>
                </div>
            </div>
    </div>
  );
}

export default TweetBox;